export const User_Api_Url = 'https://services.icdn.video/user-api/';
export const Device_Api_Url = 'https://services.icdn.video/device-api/';
export const Subscription_Api_Url = 'https://services.icdn.video/subscription-api/';
export const Socket_Url = 'http://localhost:3001/';
export const Get_All_User_Url = 'https://services.icdn.video/user-api/';
export const Get_User_Device_List = 'https://services.icdn.video/device-api/';
